<template>
  <div class="stand-dialog" v-if="isOpen">
    <div class="stand-dialog-container" ref="container">
      <div class="close-button">
        <div v-on:click="closeDialog($event)">
          <img src="@/assets/img/xmark.svg"/>
        </div>
      </div>
      <div class="stand-frame-container">
        <iframe :src="backendUrl+stand.id"></iframe>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {isDefined} from "@/utils";
import Stand from "@/entities/Stand";
import langHelper from "@/locales/langHelper";

@Options({
  props: {
    onClose: {
      required: false,
      type: Function
    }
  }
})
export default class StandDialog extends Vue {

  private isOpen: boolean = false;
  private stand: Stand;
  private backendUrl = process.env.VUE_APP_MAP_BACKEND_URL + '/maps/' + langHelper.getCurrentLang() + '/' + process.env.VUE_APP_PROJECT + '/stand/';
  private onClose: Function;

  constructor(props) {
    super(props);
  }


  public openDialog(stand: Stand): void {
    this.stand = stand;
    this.addClickListener();
    this.isOpen = true;
  }

  public closeDialog(event: Event): void {
    event.stopImmediatePropagation();
    if (isDefined(this.onClose)) {
      this.onClose();
    }
    this.removeClickListener();
    this.isOpen = false;
  }

  private addClickListener() {
    window.addEventListener('click', this.onClick);
  }

  private removeClickListener() {
    window.removeEventListener('click', this.onClick);
  }

  private onClick(event) {
    if (isDefined(this.$refs.container) && this.isOpen) {
      const container = this.$refs.container as any;
      if (isDefined(container)) {
        if (!container.contains(event.target)) {
          this.closeDialog(event);
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">

.stand-dialog {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity .3s ease;

  &-container {
    position: relative;
    width: 100%;
    max-width: 1800px;
    top: 40px;
    max-height: 90vh;
    overflow: auto;
    overscroll-behavior: contain;
    margin: 0 auto;
    transition: all .3s ease;
    background: #fff;
    box-shadow: 0 0 100px rgb(0 0 0 / 30%);


    .close-button {
      position: absolute;
      top: 0;
      right: 50px;

      > div {
        width: 50px;
        height: 50px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: white;
        background-color: var(--primary-color);
        font-size: 1.5rem;
        cursor: pointer;
        position: fixed;

        > img {
          width: 25px;
        }
      }
    }

    .stand-frame-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      > iframe {
        height: 90vh;
        border: none;
        width: 100%;
      }
    }
  }

}

</style>
